<div class="modal fade" bsModal #BusinessAccountModal="bs-modal" [config]="{ backdrop: 'static', keyboard: false }" id="BusinessAccountModal" tabindex="-1" role="dialog">
  <form [formGroup]="businessAccountForm" novalidate>
    <div class="modal-dialog modal-dialog-centered modal-xxl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Business Account</h5>
          <button type="button" class="close" aria-label="Close" (click)="closeBusinessAccountModal()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-4">
              <label for="">Company Name@if (isRequired('CompanyName')) {
                <span class="required">*</span>
              }</label>
              <input type="text" class="form-control" maxLength='50' formControlName="CompanyName">
              @if (businessAccountForm.get('CompanyName').errors  && (businessAccountForm.get('CompanyName').dirty || businessAccountForm.get('CompanyName').touched) && businessAccountForm.get('CompanyName').errors.required !== null) {
                <div class="alert alert-danger px-1"
                  >
                  @if (businessAccountForm.get('CompanyName').errors.required ) {
                    <span>
                    Company name is required </span>
                  }
                </div>
              }
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-4">
              <label for="">Contact Person First Name@if (isRequired('FirstName')) {
                <span class="required"
                >*</span>
              }</label>
              <input type="text" class="form-control" maxLength='50' formControlName="FirstName">
              @if (businessAccountForm.get('FirstName').errors  && (businessAccountForm.get('FirstName').dirty
                || businessAccountForm.get('FirstName').touched) && businessAccountForm.get('FirstName').errors.required !== null) {
                <div class="alert alert-danger px-1"
                  >
                  @if (businessAccountForm.get('FirstName').errors.required ) {
                    <span>
                    First name is required </span>
                  }
                </div>
              }
            </div>
            <div class="col-md-4 pt-3 pt-md-0">
              <label for="">Middle Name@if (isRequired('MiddleName')) {
                <span class="required">*</span>
              }</label>
              <input type="text" class="form-control" maxLength='50' formControlName="MiddleName">
              @if (businessAccountForm.get('MiddleName').errors  && (businessAccountForm.get('MiddleName').dirty
                || businessAccountForm.get('MiddleName').touched) && businessAccountForm.get('MiddleName').errors.required !== null) {
                <div class="alert alert-danger px-1"
                  >
                  @if (businessAccountForm.get('MiddleName').errors.required ) {
                    <span>
                    Middle name is required </span>
                  }
                </div>
              }
            </div>
            <div class="col-md-4 pt-3 pt-md-0">
              <label for="">Last Name@if (isRequired('LastName')) {
                <span class="required">*</span>
              }</label>
              <input type="text" class="form-control" maxLength='50' formControlName="LastName">
              @if (businessAccountForm.get('LastName').errors  && (businessAccountForm.get('LastName').dirty
                || businessAccountForm.get('LastName').touched) && businessAccountForm.get('LastName').errors.required !== null) {
                <div class="alert alert-danger px-1"
                  >
                  @if (businessAccountForm.get('LastName').errors.required ) {
                    <span>
                    Last name is required </span>
                  }
                </div>
              }
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-md-4">
              <label for="Address" i18n="@@Address">Address@if (isRequired('CompanyAddress')) {
<span class="required"
                 >*</span>
}
              </label>
            <input type="text" class="form-control" id="Address" maxlength="150" formControlName="CompanyAddress">
            @if (businessAccountForm.get('CompanyAddress').errors  && (businessAccountForm.get('CompanyAddress').dirty
              || businessAccountForm.get('CompanyAddress').touched) && businessAccountForm.get('CompanyAddress').errors.required !== null) {
              <div class="alert alert-danger px-1"
                >
                @if (businessAccountForm.get('CompanyAddress').errors.required ) {
                  <span>
                  Company Address is required </span>
                }
              </div>
            }
          </div>
          <div class="col-md-4 pt-3 pt-md-0">
            <label for="">City@if (isRequired('CompanyCity')) {
              <span class="required">*</span>
            }</label>
            <input type="text" class="form-control" maxLength='30' formControlName="CompanyCity">
            @if (businessAccountForm.get('CompanyCity').errors  && (businessAccountForm.get('CompanyCity').dirty
              || businessAccountForm.get('CompanyCity').touched) && businessAccountForm.get('CompanyCity').errors.required !== null) {
              <div class="alert alert-danger px-1"
                >
                @if (businessAccountForm.get('CompanyCity').errors.required ) {
                  <span>
                  City is required </span>
                }
              </div>
            }
          </div>
        </div>

        <div class="row mt-3">

          <div class="col-md-4">
            <label for="">State / Province@if (!emptyStateList && isRequired('CompanyState')) {
              <span class="required">*</span>
            }</label>
            <select id="inputState" class="form-select" formControlName="CompanyState">
              @if (!emptyStateList) {
                <option value="" selected i18n="@@Select">Select</option>
              }
              @if (emptyStateList) {
                <option value="0">--</option>
              }
              @for (cst of stateList; track cst) {
                <option [value]="cst.Id">{{cst.Name}}</option>
              }
            </select>
            @if (businessAccountForm.get('CompanyState').errors  && (businessAccountForm.get('CompanyState').dirty
              || businessAccountForm.get('CompanyState').touched) && businessAccountForm.get('CompanyState').errors.required !== null) {
              <div class="alert alert-danger px-1"
                >
                @if (businessAccountForm.get('CompanyState').errors.required ) {
                  <span>
                  State is required </span>
                }
              </div>
            }
          </div>
          <div class="col-md-4 pt-3 pt-md-0">
            <label for="">Zip / Postal Code@if (isRequired('CompanyZip')) {
              <span class="required">*</span>
            }</label>
            <input type="text" class="form-control" maxLength='15' formControlName="CompanyZip" (keypress)="validateZipInput($event)">
            @if (businessAccountForm.get('CompanyZip').errors  && (businessAccountForm.get('CompanyZip').dirty
              || businessAccountForm.get('CompanyZip').touched) && businessAccountForm.get('CompanyZip').errors.required !== null) {
              <div class="alert alert-danger px-1"
                >
                @if (businessAccountForm.get('CompanyZip').errors.required ) {
                  <span>
                  Zip code is required </span>
                }
              </div>
            }
          </div>
          <div class="col-md-4 pt-3 pt-md-0">
            <label for="">Country@if (isRequired('CompanyCountryId')) {
              <span class="required">*</span>
            }</label>
            <select id="inputcountry" class="form-select" formControlName="CompanyCountryId"
              (change)="onBusinessFormCountryChange($event.target.value)">
              <option value="" selected i18n="@@Select">Select</option>
              @for (cct of countryList; track cct) {
                <option [value]="cct.Id">{{cct.Name}}</option>
              }
            </select>
            @if (businessAccountForm.get('CompanyCountryId').errors  && (businessAccountForm.get('CompanyCountryId').dirty
              || businessAccountForm.get('CompanyCountryId').touched) && businessAccountForm.get('CompanyCountryId').errors.required !== null) {
              <div class="alert alert-danger px-1"
                >
                @if (businessAccountForm.get('CompanyCountryId').errors.required ) {
                  <span>
                  Country is required </span>
                }
              </div>
            }
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-md-4">
            <label>Phone@if (isRequired('CompanyPhone')) {
              <span class="required">*</span>
            }</label>
            <div class="form-group mb-0">
              <div class="phone_code">
                <select class="form-select" formControlName="CompanyPhoneCountryId">
                  <option value="" selected hidden>Select</option>
                  @for (ct of countryList; track ct) {
                    <option [value]="ct.Id">
                    {{ct.DialInCode}}</option>
                  }
                </select>
              </div>
              <div class="homephone_numb_field">
                <ejs-maskedtextbox [mask]="PhoneNumberMask" name="phone" id="inputPhone"
                  formControlName="CompanyPhone" cssClass="form-control p-0" (focus)="onStartfocus($event)">
                </ejs-maskedtextbox>

                @if (businessAccountForm.get('CompanyPhone').errors  && (businessAccountForm.get('CompanyPhone').dirty || businessAccountForm.get('CompanyPhone').touched)) {
                  <div class="alert alert-danger"
                    >
                    @if (businessAccountForm.get('CompanyPhone').errors.required) {
                      <span> Phone is required</span>
                    }
                    @if (businessAccountForm.get('CompanyPhone').errors.lessThanTen) {
                      <span>Enter 10 digit Cell Phone
                      Number</span>
                    }
                  </div>
                }
              </div>
            </div>
          </div>

          <div class="col-md-4 pt-3 pt-md-0">
            <label>Fax@if (isRequired('CompanyFax')) {
              <span class="required">*</span>
            }</label>
            <div class="form-group mb-0">
              <div class="phone_code">
                <select class="form-select" formControlName="CompanyFaxCountryId">
                  <option value="" selected hidden>Select</option>
                  @for (ct of countryList; track ct) {
                    <option [value]="ct.Id">
                    {{ct.DialInCode}}</option>
                  }
                </select>
              </div>
              <div class="homephone_numb_field">
                <ejs-maskedtextbox [mask]="PhoneNumberMask" name="phone" id="inputFax" formControlName="CompanyFax"
                  cssClass="form-control p-0" (focus)="onStartfocus($event)">
                </ejs-maskedtextbox>
                @if (businessAccountForm.get('CompanyFax').errors  && (businessAccountForm.get('CompanyFax').dirty || businessAccountForm.get('CompanyFax').touched)) {
                  <div class="alert alert-danger"
                    >
                    @if (businessAccountForm.get('CompanyFax').errors.required) {
                      <span> Fax is required</span>
                    }
                    @if (businessAccountForm.get('CompanyFax').errors.lessThanTen) {
                      <span>Enter 10 digit Fax
                      Number</span>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
          <div class="col-md-4 pt-3 pt-md-0">
            <label for="">Email@if (isRequired('CompanyEmail')) {
              <span class="required">*</span>
            }</label>
            @if (!businessAccountForm.get('NoCompanyEmail').value) {
              <div class="float-right mb-1">
                <label class="pure-material-checkbox mb-0">
                  <input type="checkbox" [(ngModel)]="defaultEmailBusinessInfo" [ngModelOptions]="{standalone: true}"
                    (click)="makePortalLogin(businessAccountForm.get('CompanyEmail').value, $event)"
                    [disabled]="!businessAccountForm.get('CompanyEmail').value || !businessAccountForm.get('CompanyEmail').valid || !allowToCreatePortalLogin">
                    <span style="font-weight: bold;">Make this Email Id as Portal Login Id</span>
                  </label>
                </div>
              }
              <input type="text" class="form-control" id="inputEmail" maxlength="250" formControlName="CompanyEmail" (blur)="onBlurFunction()"
                [pattern]="emailIdsPattern" (keypress)="restrictSpace($event)"
                (keyup)="businessInfoEmailSubject.next($event)" (paste)="businessInfoEmailSubject.next($event)">
                @if ( businessAccountForm.get('CompanyEmail').errors && (businessAccountForm.get('CompanyEmail').dirty || businessAccountForm.get('CompanyEmail').touched)) {
                  <div class="alert alert-danger"
                    >
                    @if (businessAccountForm.get('CompanyEmail').errors.required) {
                      <span> Email is required</span>
                    }
                    @if (businessAccountForm.get('CompanyEmail').errors.pattern) {
                      <span
                        i18n="@@ReportGroup_EmailIds_valid"> Enter
                  valid E-Mail ID's separated by comma or semi colon</span>
                    }
                  </div>
                }
                <label class="pure-material-checkbox float-left mt-2">
                  <input type="checkbox" class="checkBoxClass" formControlName="NoCompanyEmail"
                    (click)="onChangeNoEmail($event)">
                    <span>No Email Address Available</span>
                  </label>
                  <label class="pure-material-checkbox float-end mt-2">
                    <input type="checkbox" class="checkBoxClass" formControlName = "SendEmailAlerts" (click)="onEmailCheckboxChange()">
                    <span>Email</span>
                  </label>
                </div>

              </div>
            </div>
            <div class="modal-footer">
              <!-- <button type="button" class="btn btn-primary me-3" (click)="ResetBusinessForm()">Delete</button> -->
              <button type="button" class="btn btn-outline-primary me-3"
              (click)="onOpenCancelPOPUPforBusiness(cancelPopupforBusiness)">Cancel</button>
              <button type="button" class="btn btn-primary" (click)="businessAccountSubmitAndClose()"
              [disabled]="IsBusinessaccvalid()">Save</button>
            </div>
          </div>
        </div>
      </form>
    </div>
    <ng-template #cancelPopupforBusiness>
      <div class="modal-header">
        <h5 class="modal-title" i18n="@@Confirm">Confirm</h5>
      </div>
      <div class="modal-body ptb24">
        <p class="mb-0" i18n="@@sureCancel">
      Are you sure you want to Cancel ? Any data modifications will not be saved
    </p>
      </div>
      <div class="modal-footer">
        <button class="btn btn-outline-primary me-3" type="button" (click)="reopenBusinessAccountModal()" i18n="@@No">No</button>
        <button class="btn btn-primary" type="button" (click)="OnBusinessaccCancel()" i18n="@@Yes">Yes</button>
      </div>
    </ng-template>

    <ng-template #validateAccountExistsPortal>
      <div class="modal-header">
        <h5 class="modal-title">Confirm</h5>
      </div>
      <div class="modal-body ptb24">
        <p class="mb-0">
          User Account already exists for this Email Address! Do you want to link it to same account?
        </p>
      </div>
      <div class="modal-footer">
        <button class="btn btn-outline-primary" type="button" (click)="makeAsUnchecked()">No</button>
        <button class="btn btn-primary" type="button" (click)="addToPortalLoginList()">Yes</button>
      </div>
    </ng-template>